/**
 * Registry of Bousala products. The purchase layer resolves slugs, Paddle
 * price external ids and payment-instruction regions from here instead of
 * hardcoding a single product.
 */
export type BousalaProductKey = "v1" | "smart";

export type BousalaProductDef = {
  key: BousalaProductKey;
  slug: string;
  /**
   * Slug of the assessment instrument this product unlocks.
   * Both products intentionally point at "bousala-v1": Smart Bousala buyers
   * take the SAME Bousala 1 assessment. Smart Bousala has no instrument of
   * its own — do not "fix" this to "bousala-smart".
   */
  instrumentSlug: string;
  paddlePriceExternalId: string;
  instructionsRegion: string;
};

export const BOUSALA_PRODUCTS: Record<BousalaProductKey, BousalaProductDef> = {
  v1: {
    key: "v1",
    slug: "bousala-v1",
    instrumentSlug: "bousala-v1",
    paddlePriceExternalId: "bousala_v1_access_onetime",
    instructionsRegion: "bousala_inside_syria",
  },
  smart: {
    key: "smart",
    slug: "bousala-smart",
    // Same assessment as Bousala 1 — intentional, see instrumentSlug above.
    instrumentSlug: "bousala-v1",
    paddlePriceExternalId: "bousala_smart_access_onetime",
    instructionsRegion: "bousala_smart_inside_syria",
  },
};

export const DEFAULT_BOUSALA_PRODUCT: BousalaProductKey = "v1";

export function resolveBousalaProduct(
  key: BousalaProductKey | string | undefined | null,
): BousalaProductDef {
  const k = (key ?? DEFAULT_BOUSALA_PRODUCT) as BousalaProductKey;
  const def = BOUSALA_PRODUCTS[k];
  if (!def) throw new Error(`Unknown Bousala product key: ${String(key)}`);
  return def;
}

export function bousalaProductBySlug(slug: string): BousalaProductDef | null {
  return (
    Object.values(BOUSALA_PRODUCTS).find((p) => p.slug === slug) ?? null
  );
}
